namespace SorAraBul.Administration {

    @Serenity.Decorators.registerClass()
    export class PurchasePackageFeaturesDialog extends Serenity.EntityDialog<PurchasePackageFeaturesRow, any> {
        protected getFormKey() { return PurchasePackageFeaturesForm.formKey; }
        protected getIdProperty() { return PurchasePackageFeaturesRow.idProperty; }
        protected getLocalTextPrefix() { return PurchasePackageFeaturesRow.localTextPrefix; }
        protected getNameProperty() { return PurchasePackageFeaturesRow.nameProperty; }
        protected getService() { return PurchasePackageFeaturesService.baseUrl; }
        protected getDeletePermission() { return PurchasePackageFeaturesRow.deletePermission; }
        protected getInsertPermission() { return PurchasePackageFeaturesRow.insertPermission; }
        protected getUpdatePermission() { return PurchasePackageFeaturesRow.updatePermission; }

        protected form = new PurchasePackageFeaturesForm(this.idPrefix);
    }
}
